// src/hooks/useAdvancedView.js
//
// The page-level "Avanzate" preference (v198 — Buyer Personas first, Brand Voice next). One value PER PAGE
// (`scope`), remembered in THIS browser per user: new users see the base set, and whoever opens "Avanzate"
// keeps it open on their next visit. ⛔ Per browser only — the backend has no user-preference field.
// ⛔ `userKey` is an ARGUMENT, not read from useAuth(): useAuth throws outside AuthProvider and the persona
// suites render without one. Pages pass `user?.user_id || user?.email`.
// Every storage access is in try/catch (private window, blocked site data): a failure only means "not remembered".
import { useCallback, useState } from 'react';

export const advancedViewKey = (scope, userKey) => `advanced_view:${scope}:${userKey || 'anon'}`;

function read(key) {
  try {
    return window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

export default function useAdvancedView(scope, userKey) {
  const key = advancedViewKey(scope, userKey);
  const [state, setState] = useState(() => ({ key, on: read(key) }));
  // A different user / scope under the same mount reads ITS value, never the previous one's.
  const on = state.key === key ? state.on : read(key);
  const setOn = useCallback((next) => {
    const value = Boolean(next);
    try {
      window.localStorage.setItem(key, value ? '1' : '0');
    } catch { /* per-browser convenience only */ }
    setState({ key, on: value });
  }, [key]);
  return [on, setOn];
}
